/* tslint:disable */
/* eslint-disable */
/**
 * openapi.yml
 * オンラインCE API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostLoginRequest
 */
export interface PostLoginRequest {
    /**
     * Cognito IDトークン
     * @type {string}
     * @memberof PostLoginRequest
     */
    idToken: string;
}

/**
 * Check if a given object implements the PostLoginRequest interface.
 */
export function instanceOfPostLoginRequest(value: object): boolean {
    if (!('idToken' in value)) return false;
    return true;
}

export function PostLoginRequestFromJSON(json: any): PostLoginRequest {
    return PostLoginRequestFromJSONTyped(json, false);
}

export function PostLoginRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostLoginRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'idToken': json['idToken'],
    };
}

export function PostLoginRequestToJSON(value?: PostLoginRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'idToken': value['idToken'],
    };
}

